import httpbaseURL from "../common/axios";
class SupplierDebitNoteService {
  CreateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierDebitNote/Create", doc);
  }
  UpdateData(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/SupplierDebitNote/Update", doc);
  }
  GetList() {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierDebitNote/List");
  }
  GetData(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierDebitNote/Get?PrepaymentID=" + doc);
  }
  DeleteData(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/SupplierDebitNote/Delete?PrepaymentID=" + doc
    );
  }
  GetDebitNoteList(Id,HId,BId) {
    return httpbaseURL.httpMSInventoryUrl.get("/SupplierDebitNote/GetDebitNoteBySupplierId?SupplierId="+Id+"&HospitalId="+ HId +"&BranchId="+ BId);
  }
 
}
export default new SupplierDebitNoteService();
